import { css } from "styled-components";
import { getThemeFontSize, getThemeMedia } from "../helpers";
export const DEFAULT_VARIANT = "Paragraph/Regular";
export const DEFAULT_COLOR = "--text-primary";
const getStyles = (size, weight, lineHeight, options) => css `
	font-size: ${getThemeFontSize(size)};
	font-weight: ${weight};
	line-height: ${getThemeFontSize(lineHeight)};

	${options?.mono && "font-family: monospace !important;"}
	${options?.italic && "font-style: italic;"}
	${options?.underline && "text-decoration: underline;"}
`;
const typographyStyles = {
    "Headline/H1 Bold": getStyles("32", 700, "40"),
    "Headline/H1 Semibold": getStyles("32", 600, "40"),
    "Headline/H1 Regular": getStyles("32", 400, "40"),
    "Headline/H2 Bold": getStyles("24", 700, "32"),
    "Headline/H2 Semibold": getStyles("24", 600, "32"),
    "Headline/H2 Regular": getStyles("24", 400, "32"),
    Subtitle: getStyles("20", 600, "24"),
    "Paragraph/Semibold": getStyles("16", 600, "24"),
    "Paragraph/Regular": getStyles("16", 400, "24"),
    "Paragraph/Underline": getStyles("16", 400, "24", { underline: true }),
    "Paragraph/Italic": getStyles("16", 400, "24", { italic: true }),
    "ParagraphSmall/Semibold": getStyles("14", 600, "20"),
    "ParagraphSmall/Regular": getStyles("14", 400, "20"),
    "ParagraphSmall/Italic": getStyles("14", 400, "20", { italic: true }),
    "Caption/Regular": getStyles("12", 400, "16"),
    "Caption/Italic": getStyles("12", 400, "16", { italic: true }),
    Mono: getStyles("14", 400, "24", { mono: true }),
};
export const getVariantByResponsiveProps = (variant) => {
    if (typeof variant === "string")
        return typographyStyles[variant];
    return css `
		${typographyStyles[variant?.small || DEFAULT_VARIANT]}

		@media screen {
			@media (min-width: ${getThemeMedia("medium")}) {
				${typographyStyles[variant?.medium || variant?.small || DEFAULT_VARIANT]}
			}

			@media (min-width: ${getThemeMedia("large")}) {
				${typographyStyles[variant?.large || variant?.medium || variant?.small || DEFAULT_VARIANT]}
			}
		}
	`;
};
const tagConverter = (variant) => {
    const currentVariant = variant.toLowerCase();
    if (currentVariant.includes("h1"))
        return "h1";
    if (currentVariant.includes("h2"))
        return "h2";
    if (currentVariant.includes("subtitle"))
        return "h2";
    if (currentVariant.includes("italic"))
        return "em";
    return "p";
};
export const tagReplacerByVariant = (variant) => {
    if (!variant)
        return "p";
    if (typeof variant === "string")
        return tagConverter(variant);
    if (variant?.small)
        return tagConverter(variant.small);
    if (variant?.medium)
        return tagConverter(variant.medium);
    return tagConverter(variant?.large || DEFAULT_VARIANT);
};
//# sourceMappingURL=helpers.js.map